import { render, staticRenderFns } from "./SlaRulesManager.vue?vue&type=template&id=c8518494&scoped=true"
import script from "./SlaRulesManager.vue?vue&type=script&lang=js"
export * from "./SlaRulesManager.vue?vue&type=script&lang=js"
import style0 from "./SlaRulesManager.vue?vue&type=style&index=0&id=c8518494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8518494",
  null
  
)

export default component.exports